import type { PermissionGroup as GQLItem } from '../../../generated/api.graphql';
import { take } from '../../../util';
import * as Permission from './Permission';

export type PermissionGroup = {
  icon?: string;
  key: string;
  label: string;
  permissions: Permission.Permission[];
};

// See the note on `Permission.fromGql` for why `icon` is normalised rather than taken.
export const fromGql = (item: GQLItem): PermissionGroup => ({
  ...take<Omit<PermissionGroup, 'icon' | 'permissions'>>(item, 'key', 'label'),
  icon: item.icon ?? undefined,
  permissions: item.permissions?.map(Permission.fromGql) ?? [],
});
